// test487
(487 && 0);
